module.exports = __webpack_public_path__ + "static/BYJ-e683d18902a52e30429f1dd9e852d5a2.jpg";